// extracted by mini-css-extract-plugin
export var redoItem = "_o2-1";
export var redoTrigger = "_o2-0";